<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>
